
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class UploadQueue extends Vue {
  @Prop() mediaItems!:File[]

  deleteMediaItem (index:number) : void {
    this.$emit('fileDeleted', index)
  }
}
